import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
import { Observable } from 'rxjs';
import { Schools } from 'src/app/core/models/schools';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { SchoolsService } from 'src/app/core/services/schools.service';
import { SnackBarAlertsService } from 'src/app/core/services/snackbar-alerts.service';
import { State, StateCountryEventService } from 'src/app/core/services/state-country-event.service';
import { Subscriptions } from '../../shared/subscriptions';

@Component({
  selector: 'app-school-address-information',
  templateUrl: './school-address-information.component.html',
  styleUrls: ['./school-address-information.component.scss']
})
export class SchoolAddressInformationComponent implements OnInit, OnDestroy {
  @Input() selectedSchoolId: string;

  schoolData: Schools;
  editModeOff: boolean;
  form: UntypedFormGroup;
  isSchoolUser: boolean;
  wrongUser: boolean;
  isServicerConfiguration = false;
  subscriptions = new Subscriptions();
  state: string;
  states$: Observable<State[]> = this.stateCountryService.states$;

  // being used for showing error while typing
  matcher = new ShowOnDirtyErrorStateMatcher();

  constructor(
    private fb: UntypedFormBuilder,
    private authService: AuthenticationService,
    private alerts: SnackBarAlertsService,
    private schoolsService: SchoolsService,
    private stateCountryService: StateCountryEventService
  ) {
    this.isServicerConfiguration = this.authService.isServicerConfigUser();
    this.isSchoolUser = this.authService.isSchoolUser();
    if ( this.isSchoolUser === true || this.isServicerConfiguration === true) {
      this.wrongUser === false;
    }
  }

  ngOnInit(): void {
    this.schoolsService.getSchoolsById(this.selectedSchoolId).subscribe(
      data => {
        this.schoolData = data;
        this.createForm();
      },
      error => {
        console.log(error);
      }
    );
  }
  createForm() {
    this.form = this.fb.group({
      street1: [{ value: this.schoolData.address.street1, disabled: false }],
      street2: [{ value: this.schoolData.address.street2, disabled: false }],
      city: [{ value: this.schoolData.address.city, disabled: false }],
      state: [{ value: this.schoolData.address.state, disabled: false }],
      postalCode: [{ value: this.schoolData.address.postalCode, disabled: false }]
    });
  }

  // reverts form to previous values
  revertForm() {
    this.createForm();
    this.form.markAsPristine();
  }

  // edit or cancel form
  editForm() {
    this.form.enable();
    this.editModeOff = true;
  }
  cancelEdit() {
    this.form.disable();
    this.editModeOff = false;
  }

  submit() {
    const originalSchoolObj = this.schoolData;
    const address = this.form.value;
    /* merge this into the form object, allowing form value to overwrite original values */
    const mergedObj = { ...originalSchoolObj, address };
    this.subscriptions.add = this.schoolsService.updateSchool(this.selectedSchoolId, mergedObj).subscribe(
      data => {
        this.schoolData = data;
        this.form.patchValue(data.address);
        this.editModeOff = false;
        this.alerts.show('Update was successful!');
      },
      () => {
        this.alerts.show('Update has failed!');
      }
    );
  }

  // destroying our subscriptions
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
